import PropTypes from "prop-types";

import Pager from "./facetedSearch/Pager";
import T from "./translations/Translations";

import { formatUsaDate } from "../utils/DateFormatter";
import { formatUsd } from "../utils/NumberFormatter";

import "../styles/PaymentsTable.scss";

const PaymentsTable = ({ facetPagination, setPageNum, payments }) => {
    const headers = [
        "Vendor",
        "Payment Date",
        "PO #",
        "Check #",
        "Amount",
        "Payment Type",
        "Fund",
        "Location",
        "Spend Category",
        "Program",
        "Description",
        "Grant",
        "Initiative",
        "Project"
    ];
    const colSpan = headers.length;

    return (
        <div className="payments-table">
            <table className="mt-4">
                <thead className="sticky-top z-1">
                    <tr>
                        {headers.map((header, index) => {
                            const uniqueKey = `payment-header-${index}`;
                            return <th key={uniqueKey}>{header}</th>;
                        })}
                    </tr>
                </thead>
                <tbody>
                    {payments.length > 0 &&
                        payments.map((payment, index) => {
                            const uniqueKey = `payment-${payment.key}-${index}`;
                            const stripe = index % 2 === 0 ? "" : "stripe";
                            return (
                                <tr className={stripe} key={uniqueKey}>
                                    <td className="first">{payment.vendorName}</td>
                                    <td>{formatUsaDate(payment.paymentDateDisplay)}</td>
                                    <td>{payment.poNumber}</td>
                                    <td>{payment.checkNumber}</td>
                                    <td align="right">{formatUsd.format(payment.paymentAmount)}</td>
                                    <td>{payment.paymentType}</td>
                                    <td>{payment.fundName}</td>
                                    <td>{payment.costCenterName}</td>
                                    <td>{payment.spendCategoryName}</td>
                                    <td>{payment.programName}</td>
                                    <td>{payment.lineDescription}</td>
                                    <td>{payment.grantName}</td>
                                    <td>{payment.initiativeName}</td>
                                    <td>{payment.projectName}</td>
                                </tr>
                            );
                        })}
                    {payments.length === 0 && (
                        <tr>
                            <td className="center first last" colSpan={colSpan}>
                                <div>{T({ key: "Results_No_Results" })}</div>
                            </td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={colSpan}>
                            {facetPagination && payments.length > 0 && (
                                <div>
                                    <Pager facetPagination={facetPagination} setPageNum={setPageNum} />
                                </div>
                            )}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

PaymentsTable.propTypes = {
    facetPagination: PropTypes.oneOfType([PropTypes.object]).isRequired,
    setPageNum: PropTypes.func.isRequired,
    payments: PropTypes.instanceOf(Array).isRequired
};

export default PaymentsTable;
